import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

export type Db = SupabaseClient<Database>;
export type SupabaseConfig = { url: string; publishableKey: string };

/** Reads the public Supabase settings; null when the app runs without a backend (local-only mode). */
export function supabaseConfig(env: Record<string, unknown> = import.meta.env): SupabaseConfig | null {
  const url = env.VITE_SUPABASE_URL;
  const publishableKey = env.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (typeof url !== 'string' || typeof publishableKey !== 'string' || !url || !publishableKey) return null;
  return { url, publishableKey };
}

let client: Db | null | undefined;

/** Lazily created client; never throws at import so tests and builds run without configuration. */
export function getSupabase(): Db | null {
  if (client === undefined) {
    const config = supabaseConfig();
    client = config
      ? createClient<Database>(config.url, config.publishableKey, {
          // PKCE: OAuth and magic links come back with a one-time `code`, never with tokens in the URL.
          // The callback route exchanges it explicitly (detectSessionInUrl off).
          auth: { flowType: 'pkce', detectSessionInUrl: false, persistSession: true, autoRefreshToken: true },
        })
      : null;
  }
  return client;
}
